import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTranslatableData } from "../hooks/useTranslatable";
import CategoryService from '../services/category.service';
import { Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const Informations = ({ currentTherapist, filter = null, axios, auth }) => {
  // console.log({ currentTherapist })
  const [categoriesCurrent, setCategoriesCurrent] = useState([]);
  const translatedSelectedCategories = useTranslatableData(categoriesCurrent);
  const { t, i18n } = useTranslation('therapist');
  // console.log({ categoriesCurrent })


  useEffect(() => {
    if (currentTherapist?.categories?.length > 0) {
      fetchCategoriesData();
    }
  }, [currentTherapist]);

  const fetchCategoriesData = async () => {
    try {
      const categoryIds = currentTherapist.categories.map(cat => cat.id);

      const response = await CategoryService.index(
        {
          id: `in:${categoryIds.join(',')}`,
          is_active: 1,
          with: 'domain,domain.hotel'
        },
        axios,
        auth?.accessToken ? false : true
      );

      let filteredCategories;

      if (filter) {
        filteredCategories = response.filter(cat => cat.domain?.hotel?.id === filter);
      } else {
        filteredCategories = response.filter(cat => cat.domain?.hotel === null);
      }

      setCategoriesCurrent(filteredCategories);
      return filteredCategories;
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategoriesCurrent([]);
    }
  }

  let parsedTags = {};
  try {
    const rawTags = currentTherapist?.tags;
    if (rawTags) {
      parsedTags = typeof rawTags === 'string' ? JSON.parse(rawTags) : rawTags;
    }
  } catch (error) {
    parsedTags = {};
  }

  // determine current language (fr or en)
  const lang = (i18n?.language || 'fr').slice(0, 2);
  const bioText = parsedTags?.bio ? (typeof parsedTags.bio === 'string' ? parsedTags.bio : (parsedTags.bio[lang] || parsedTags.bio.fr || parsedTags.bio.en || '')) : '';

  // helper: translate API language identifiers to localized display names
  const translateLanguage = (raw) => {
    if (!raw) return '';
    const r = String(raw).toLowerCase().trim();

    const normalization = {
      fr: 'french',
      fr_fr: 'french',
      french: 'french',
      en: 'english',
      en_us: 'english',
      en_gb: 'english',
      english: 'english',
      de: 'german',
      german: 'german',
      it: 'italian',
      italian: 'italian',
      es: 'spanish',
      spanish: 'spanish',
      ar: 'arabic',
      arabic: 'arabic',
      pt: 'portuguese',
      portuguese: 'portuguese',
      ru: 'russian',
      russian: 'russian'
    };

    const key = normalization[r] || normalization[r.split('-')[0]] || r;

    const knownKeys = ['french', 'english', 'german', 'italian', 'spanish', 'arabic', 'portuguese', 'russian'];
    if (knownKeys.includes(key)) {
      const groupedKey = `languages.${key}`;
      const grouped = t(groupedKey);
      if (grouped && grouped !== groupedKey) return grouped;

      const flat = t(key);
      if (flat && flat !== key) return flat;
    }

    return raw.charAt(0).toUpperCase() + raw.slice(1);
  };

  return (
    <div className="modal-therapist">
      <h3 className='info-title'>Informations</h3>
      <div className="informations">

        <h4>Bio</h4>
        <p>{bioText}</p>

      </div>
      {parsedTags?.experience && Array.isArray(parsedTags.experience) && parsedTags?.experience?.length > 0 && (
        <div className="informations">
          <h4>{t('experience')}</h4>
          <ul className='list-soin'>
            {parsedTags.experience.map((experience, index) => <li key={index}>{experience}</li>)}
          </ul>

        </div>
      )}
      <div className="informations">

        <h4>{t('soins')}</h4>
        <ul className='list-soin'>
          {/* {parsedTags?.experience && Array.isArray(parsedTags.experience) ? (
            parsedTags.experience.map((experience, index) => <li key={index}>{experience}</li>)
          ) : (
            <li>Aucune expérience renseignée</li>
          )} */}
          {translatedSelectedCategories?.length > 0 ? (
            translatedSelectedCategories.map((category, index) => (
              <li key={`cat-${index}`}>
                {category.title}
                {category.is_hidden && !filter && window.location.pathname !== "/fav-flypro" && (
                  <Tooltip
                    title={t('hidden_cats')}
                    placement="top"
                    arrow
                    slotProps={{
                      popper: {
                        sx: {
                          '& .MuiTooltip-tooltip': {
                            backgroundColor: '#393d44',
                            color: '#fff',
                            fontSize: '1rem',
                            padding: '8px 12px',
                            borderRadius: '8px',
                          },
                          '& .MuiTooltip-arrow': {
                            color: '#393d44',
                          }
                        }
                      }
                    }}
                  >
                    <InfoIcon style={{ marginLeft: '5px', cursor: 'pointer', fontSize: '1.1rem', color: 'rgba(0, 0, 0, 0.54)', }} />
                  </Tooltip>
                )}
              </li>
            ))
          ) : (
            <li>{t('aucune_experience')}</li>
          )}
        </ul>

      </div>
      <div className="informations" style={{ marginBottom: "50px" }}>

        <h4>{t('language')}</h4>
        <p>
          {parsedTags?.language && Array.isArray(parsedTags.language) ? (
            parsedTags.language.map((language, index) => (
              <span key={index}>
                {translateLanguage(language)}
                {index < parsedTags.language.length - 1 ? ", " : ""}
              </span>
            ))
          ) : (
            <li>{t("aucune_langue")}</li>
          )}
        </p>

      </div>
    </div>
  );
};

export default Informations;
